<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            d="M14 8H10.414L8.707 6.293C8.519 6.105 8.265 6 8 6H6C5.448 6 5 6.448 5 7V13C5 14.105 5.895 15 7 15H13C14.105 15 15 14.105 15 13V9C15 8.448 14.552 8 14 8Z"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M11 4C11 3.448 10.552 3 10 3H6.414L4.707 1.293C4.519 1.105 4.265 1 4 1H2C1.448 1 1 1.448 1 2V8C1 8.74 1.402 9.386 2 9.732"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
